"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _Danger = _interopRequireDefault(require("@rsuite/icon-font/lib/application/Danger"));

// Generated by script, don't edit it please.
var Danger = (0, _createSvgIcon["default"])({
  as: _Danger["default"],
  ariaLabel: 'danger',
  category: 'application',
  displayName: 'Danger'
});
var _default = Danger;
exports["default"] = _default;
module.exports = exports.default;